/** Dados institucionais usados como fallback quando o usuário não os preenche. */
// TODO: Mover para registro da assinatura no banco quando implementar plataforma de criação de assinaturas.
export const GENERAL_DATA = {
  whatsapp: "https://wa.me/551148105438",
  street_address: "Rua Luiz Seráphico Júnior, 511",
  city: "São Paulo",
  state: "SP",
  zip_code: "04729-080",
  country: "Brasil",
  office_phone_1: "+55 (11) 4810-5438",
  office_phone_2: "+55 (11) 4810-5435"
}
